var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{ outline: _vm.outline, disabled: _vm.disabled, rect: _vm.rect, small: _vm.small, auto: _vm.auto, ...{ [_vm.color]: true }},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }